
const newModel = () => {
    return {
        loginHistoryId: null,
        appId: null,
        appName: null,
        userId: null,
        userName: null,
        hoTen: null,
        loginTime: null,
        device: null,
        browser: null,
        platform: null,
    }
}

const newFEModel = () => {
    return {
        loginHistoryId: null,
        appId: null,
        appName: null,
        userId: null,
        userName: null,
        hoTen: null,
        loginTime: null,
        device: null,
        browser: null,
        platform: null,
    }
}

const fromJson = (item) => {
    return {
        loginHistoryId: null,
        appId: null,
        appName: null,
        userId: null,
        userName: null,
        hoTen: null,
        loginTime: null,
        device: null,
        browser: null,
        platform: null,
    }
}





export const lichSuDangNhapModel = {
    newModel,
    newFEModel,
    fromJson,
}


